// use intersection observer to show and hide a scroll to top button - target the site-footer

const footer = document.querySelector('.site-footer');

const siteWrap = document.querySelector('.site-wrap');

const scrollBtnOffset = siteWrap.offsetHeight * 0.45;

const scrollToTopBtn = document.querySelector('.scroll-to-top-button');
const rootElement = document.documentElement;

// Next we want to create a function that will be called when that element is intersected
function callback(entries) {
	// The callback will return an array of entries, even if you are only observing a single item
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			// Show button
			scrollToTopBtn.classList.add('show-button');
		} else {
			// Hide button
			scrollToTopBtn.classList.remove('show-button');
		}
	});
}

function scrollToTop() {
	rootElement.scrollTo({
		top: 0,
	});
}
scrollToTopBtn.addEventListener('click', scrollToTop);

// Next we instantiate the observer with the function we created above. This takes an optional configuration
// object that we will use in the other examples.
const options = {
	rootMargin: '0px 0px ' + scrollBtnOffset + 'px 0px',
};

const observer = new IntersectionObserver(callback, options);
// Finally start observing the target element

observer.observe(footer);
